import type { ReactNode } from 'react';

import { ApiContext } from './api-context';
import type { ApiClient } from './client';

export function ApiProvider({ client, children }: { client: ApiClient; children: ReactNode }) {
  return <ApiContext value={client}>{children}</ApiContext>;
}
